// Lumina Pro à faire tourner : glisser pour tourner, un point rose pour approcher
// un détail. Chargé seulement quand la section arrive près de l'écran.
const racine = document.querySelector('[data-sol3d]');
if (racine && !racine.dataset.ok) {
  racine.dataset.ok = '1';
  const scene3d = racine.querySelector('.sol-3d__scene');
  const toile = racine.querySelector('canvas');
  const puces = [...racine.querySelectorAll('[data-sol3d-c]')];
  const textes = [...racine.querySelectorAll('[data-sol3d-t]')];
  const points = [...racine.querySelectorAll('[data-sol3d-p]')];
  const touches = [...racine.querySelectorAll('[data-sol3d-touche]')];
  const couleurs = [...racine.querySelectorAll('[data-sol3d-coul]')];
  const niveaux = [...racine.querySelectorAll('[data-sol3d-niv]')];
  const halo = racine.querySelector('.sol-3d__halo');
  let courant = '', enCommande = false, niveau = 1, coul = 0, pilote = { choisir() {}, regler() {}, commande() {} };

  const regler = () => {
    const c = couleurs[coul];
    if (!c) return;
    couleurs.forEach((x, i) => { x.hidden = i !== coul; });
    niveaux.forEach((x, i) => { x.hidden = i !== niveau - 1; });
    racine.querySelectorAll('[data-sol3d-val="intensite"]').forEach((x) => { x.textContent = niveau + ' / 5'; });
    racine.querySelectorAll('[data-sol3d-val="couleur"]').forEach((x) => { x.textContent = c.dataset.nom; });
    racine.style.setProperty('--sol3d-led', c.dataset.hex);
    racine.style.setProperty('--sol3d-force', (0.12 + niveau * 0.11).toFixed(2));
    pilote.regler(niveau, c.dataset.hex);
  };
  touches.forEach((b) => b.addEventListener('click', () => {
    if (b.dataset.sol3dTouche === 'intensite') niveau = niveau % 5 + 1;
    else coul = (coul + 1) % couleurs.length;
    racine.classList.add('is-utilise');
    regler();
    pilote.commande();
  }));
  regler();

  const choisir = (c) => {
    courant = c === courant ? '' : c;
    racine.classList.add('is-utilise');
    puces.forEach((p) => { const on = p.dataset.sol3dC === courant; p.classList.toggle('is-on', on); p.setAttribute('aria-pressed', on); });
    points.forEach((p) => p.classList.toggle('is-on', p.dataset.sol3dP === courant));
    textes.forEach((p) => { p.hidden = p.dataset.sol3dT !== (courant || '_'); });
    pilote.choisir(courant);
  };
  puces.forEach((p) => p.addEventListener('click', () => choisir(p.dataset.sol3dC)));
  points.forEach((p) => p.addEventListener('click', () => choisir(p.dataset.sol3dP)));

  const io = new IntersectionObserver((e) => {
    if (e[0].isIntersecting) { io.disconnect(); demarrer(); }
  }, { rootMargin: '600px' });
  io.observe(racine);

  async function demarrer() {
    let T, M;
    try { [T, M] = await Promise.all([import(racine.dataset.three), import(racine.dataset.modele)]); }
    catch (e) { racine.classList.add('is-sans3d'); return; }
    let rendu;
    try { rendu = new T.WebGLRenderer({ canvas: toile, alpha: true, antialias: true }); }
    catch (e) { racine.classList.add('is-sans3d'); return; }
    rendu.outputColorSpace = T.SRGBColorSpace;
    rendu.toneMapping = T.LinearToneMapping;
    rendu.toneMappingExposure = 1;
    rendu.setPixelRatio(Math.min(devicePixelRatio || 1, 2));

    const scene = new T.Scene();
    const cam = new T.PerspectiveCamera(28, 1, 0.1, 100);
    M.eclairer(T, rendu, scene);
    const lumina = M.construireLumina(T);
    const pivot = new T.Group();
    pivot.add(lumina.groupe);
    scene.add(pivot);
    lumina.allumer(0.9);

    const VUES = {
      '': { y: -0.3, x: 0.1, z: 11.4, cy: 0 },
      tete: { y: 0, x: 0.42, z: 5.2, cy: 1.72 },
      ecran: { y: -0.14, x: 0.02, z: 4.8, cy: 0.86 },
      boutons: { y: 0.16, x: 0.04, z: 4.8, cy: 0.1 },
      corps: { y: 0.5, x: 0.1, z: 7.6, cy: -0.8 },
      commande: { y: -0.08, x: 0.12, z: 8.2, cy: 0.62 },
    };
    let lacet = -0.3, tangage = 0.1, z = 11.4, cy = 0, cible = VUES[''], glisse = false, gx = 0, gy = 0, libre = 0, repos = 0;
    pilote = {
      choisir(c) { enCommande = false; cible = VUES[c] || VUES['']; libre = 0; repos = c ? 1 : 0; },
      regler(n, teinte) { lumina.regler(n, teinte); },
      // Un bouton pressé : l'appareil cesse de tourner et se présente de face.
      commande() { if (!courant) { enCommande = true; cible = VUES.commande; libre = 0; repos = 1; } },
    };
    regler();

    scene3d.addEventListener('pointerdown', (e) => {
      if (e.target.closest('button')) return;
      glisse = true; gx = e.clientX; gy = e.clientY;
      scene3d.setPointerCapture(e.pointerId);
      racine.classList.add('is-utilise');
    });
    scene3d.addEventListener('pointermove', (e) => {
      if (!glisse) return;
      lacet += (e.clientX - gx) * 0.011;
      tangage = Math.max(-0.5, Math.min(0.7, tangage + (e.clientY - gy) * 0.005));
      gx = e.clientX; gy = e.clientY; libre = 1;
    });
    const lacher = () => { glisse = false; };
    scene3d.addEventListener('pointerup', lacher);
    scene3d.addEventListener('pointercancel', lacher);

    const taille = () => {
      const l = scene3d.clientWidth, h = scene3d.clientHeight;
      if (!l || !h) return;
      rendu.setSize(l, h, false);
      cam.aspect = l / h;
      cam.updateProjectionMatrix();
    };
    new ResizeObserver(taille).observe(scene3d);
    taille();

    let visible = true, dernier = 0;
    new IntersectionObserver((e) => { visible = e[0].isIntersecting; }).observe(racine);
    const calme = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const v = new T.Vector3();

    function image(t) {
      requestAnimationFrame(image);
      if (!visible) return;
      const dt = dernier ? Math.min(0.05, (t - dernier) / 1000) : 0.016;
      dernier = t;
      if (!libre && !repos && !calme && !glisse) cible = { ...cible, y: cible.y + dt * 0.28 };
      if (!libre) { lacet += (cible.y - lacet) * Math.min(1, dt * 3.4); tangage += (cible.x - tangage) * Math.min(1, dt * 3.4); }
      z += (cible.z - z) * Math.min(1, dt * 3);
      cy += (cible.cy - cy) * Math.min(1, dt * 3);
      pivot.rotation.set(tangage, lacet, 0);
      cam.position.set(0, cy, z);
      cam.lookAt(0, cy, 0);
      rendu.render(scene, cam);

      points.forEach((p) => {
        const r = lumina.reperes[p.dataset.sol3dP];
        if (!r) return;
        v.copy(r);
        lumina.groupe.localToWorld(v);
        const devant = v.z > -0.05;
        v.project(cam);
        p.style.left = (v.x * 50 + 50) + '%';
        p.style.top = (50 - v.y * 50) + '%';
        p.classList.toggle('is-cache', !devant || !!courant || enCommande);
      });

      // Les vrais boutons de l'appareil, à la taille qu'ils ont à l'écran.
      const ecart = { intensite: 0, couleur: 0 };
      const hauteur = scene3d.clientHeight;
      touches.filter((b) => b.closest('.sol-3d__scene')).forEach((b) => {
        const r = lumina.reperes[b.dataset.sol3dTouche];
        v.copy(r);
        lumina.groupe.localToWorld(v);
        const devant = v.z > 0.1;
        v.project(cam);
        ecart[b.dataset.sol3dTouche] = v.y;
        b.style.left = (v.x * 50 + 50) + '%';
        b.style.top = (50 - v.y * 50) + '%';
        b.classList.toggle('is-cache', !devant);
      });
      const cote = Math.max(24, Math.min(110, Math.abs(ecart.intensite - ecart.couleur) * hauteur / 2));
      racine.style.setProperty('--sol3d-touche', cote.toFixed(1) + 'px');
      if (halo) {
        v.copy(lumina.reperes.tete);
        lumina.groupe.localToWorld(v);
        v.project(cam);
        halo.style.left = (v.x * 50 + 50) + '%';
        halo.style.top = (50 - v.y * 50) + '%';
      }
    }
    requestAnimationFrame(image);
  }
}
